import { observer } from 'mobx-react';
import Main from '../../../../BrowserSupport/Main';
import Notifications from '../../../../Notifications';
import I18nTitle from '../../../../Title/I18nTitle';
import Chat from '../../../Chatbot/Chat';
import { AutoScrollProvider } from '../../../Chatbot/Chat/AutoScrollContext';
import Header from './Header';
import Previewer from './Previewer';

function ActivePreview() {
  return (
    <>
      <I18nTitle title="Preview" />
      <Notifications />
      <Main
        id="main"
        className="max-w-clientPortalMaxWidth w-full mx-auto relative flex flex-col flex-1"
      >
        <Header />
        <div className="flex flex-1">
          <div id="preview-container" className="w-9/12 flex relative mr-px">
            <Previewer />
          </div>
          <div className="w-3/12 border-l border-t xxl:border-r flex relative">
            <AutoScrollProvider>
              <Chat />
            </AutoScrollProvider>
          </div>
        </div>
      </Main>
    </>
  );
}

export default observer(ActivePreview);
